/**
 * 新疆舆情最新话题规则
 * 2017-12-27
 * by 于再洋
 */
"use strict";
angular.module("newTopicRuleModule", []).
controller("newTopicRuleCtrl", ["$scope", "trsHttpService", "burstNewsRuleService", "modalDialog", function($scope, trsHttpService, burstNewsRuleService, modalDialog) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {
            page: {
                CURRPAGE: 1,
                PAGESIZE: 10,
                ITEMCOUNT: '',
                PAGECOUNT: '',
                copyCurrPage: 1,
            }
        };

        $scope.data = {
            searchWord: '',
        };
    }
    /**
     * [initData description] 初始化数据
     * @return {[type]} [description]
     */
    function initData() {
        requestData();
    }

    /**
     * [searchData description] 搜索
     * @return {[type]} [description]
     */
    $scope.searchData = function(ev) {
        if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
            requestData();
        }
    };

    /**
     * [searchData description] 搜索
     * @return {[type]} [description]
     */
    function requestData() {
        $scope.params = {
            "typeid": 'screen',
            "serviceid": 'zjsentimentrulemgr',
            "modelid": 'getrulelist',
            "type": '1',
            "search_word": $scope.data.searchWord,
            "page_size": $scope.status.page.PAGESIZE,
            "page_no": $scope.status.page.copyCurrPage - 1
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, "post").then(function(data) {
            $scope.status.page.PAGECOUNT = data.totalPages;
            $scope.status.page.ITEMCOUNT = data.totalElements;
            var newsList = [];
            if (data.content) {
                for (var i = 0; i < data.content.length; i++) {
                    newsList.push(data.content[i]);
                }
            }

            $scope.dataList = angular.copy(newsList);
            for (var i = 0; i < $scope.dataList.length; i++) {
                if ($scope.dataList[i].content.length > 300) {
                    $scope.dataList[i].content = $scope.dataList[i].content.substr(0, 300) + "……";
                    $scope.dataList[i].show = true;
                } else {
                    $scope.dataList[i].content = $scope.dataList[i].content;
                    $scope.dataList[i].show = false;
                }
            }
            $scope.newTopicList = newsList;
        });
    }
    /*
     *[pageChanged description:跳转页面]
     */
    $scope.pageChanged = function() {
        $scope.status.page.copyCurrPage = $scope.status.page.CURRPAGE;
        $scope.params.page_no = $scope.status.page.copyCurrPage;
        requestData();
    };
    /*
     *[jumpToPage description:跳转到指定页面]
     */
    $scope.jumpToPage = function() {
        if (!$scope.status.page.copyCurrPage) return;
        if ($scope.status.page.copyCurrPage > $scope.status.page.PAGECOUNT) {
            $scope.status.page.copyCurrPage = $scope.status.page.PAGECOUNT;
        }
        $scope.status.page.CURRPAGE = $scope.status.page.copyCurrPage;
        requestData();
    };
    /**
     * [openCheck description] 查看弹窗
     * @return {[type]} [description]
     */
    $scope.openCheck = function(id) {
        burstNewsRuleService.brcheck(id, 1).then(function(data) {
            if (data == true) {
                requestData();
            }
        });
    }
    /**
     * [del description] 删除弹窗
     * @return {[type]} [description]
     */
    $scope.listdel = function(id) {
        modalDialog.confirmModal("删除提示", "是否确定删除？", function() {
            var params = {
                "typeid": 'screen',
                "serviceid": 'zjsentimentrulemgr',
                "modelid": 'deleterule',
                'id': id,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
                requestData();
                if ($scope.dataList.length == 1) {
                    $scope.data.searchWord = "";
                }
            });
        });
    };

    /**
     * [editrule description] 编辑弹窗
     * @return {[type]} [description]
     */
    $scope.editrule = function(id) {
        burstNewsRuleService.breditrule(id, 1).then(function(data) {
            if (data == true) {
                requestData();
            }
        });
    }
    /**
     * [addrule description] 添加弹窗
     * @return {[type]} [description]
     */
    $scope.addrule = function() {
        burstNewsRuleService.braddrule(1).then(function(data) {
            if (data == true) {
                requestData();
            }
        });
    }

    /**
     * [help description] 帮助弹窗
     * @return {[type]} [description]
     */
    $scope.help = function() {
        burstNewsRuleService.help();
    };
}]);